import { ILeagueGroupDictionaryApi } from '@/types';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { LeagueGroupDictionaryItem } from '@/models/dictionary/leagueGroup';

export const useLeagueGroupDictionary = defineStore('leagueGroupDictionary', () => {
    const items = shallowRef<LeagueGroupDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    // actions
    function setData(data: ILeagueGroupDictionaryApi[]) {
        console.time('set-leagueGroup-dictionary');
        items.value = data.map((item) => new LeagueGroupDictionaryItem(item));
        console.timeEnd('set-leagueGroup-dictionary');
    }

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
